// Approved HestiaDoors threshold reference, 2026-11-02.
// Detail coordinates: [depth from inside toe, height above floor], mm.
export const ALU_THRESHOLD_PROFILE_MM = [
  [0,0],[0,1.7],[42,11.4],[42,3],[49,3],[49,24.8],
  [52.8,24.8],[52.8,20],[115,7.3],[115,0]
];
// Register the inside toe to the existing frame's Z datum.
export const ALU_THRESHOLD_SECTION_MM = ALU_THRESHOLD_PROFILE_MM.map(([x,y])=>[x-52.5,y]);

// Saved Studio workspaces contain a copy of their defaults. Recognise only the
// complete old GLB-derived default; genuinely edited sections stay untouched.
export const LEGACY_ALU_SECTIONS = [
  [[60.98,47.25],[60.98,48.73],[-35.83,48.73],[-35.83,49.73],[-52.5,49.73],[-52.5,46.65],[-10.78,41.04],[-10.28,44.88],[-0.33,44.57],[-0.33,28.11],[1.66,28.11],[1.66,46.41],[-11.93,46.82],[-12.41,43.17],[-50.61,48.31],[-50.61,49.72],[-35.83,49.71],[-35.83,49.73],[62.04,49.73],[62.04,48.29],[63.93,48.29],[63.94,44.5],[3.28,32.11],[3.24,33.95],[1.97,33.95],[1.97,27.94],[-0.86,27.94],[-0.86,26.44],[-0.12,25.73],[0.94,25.73],[3.46,27.28],[3.46,29.68],[65.5,42.42],[65.5,49.73],[62.04,49.73],[62.04,48.25],[63.94,48.25],[63.94,45.33],[62.88,45.33],[62.88,47.25]],
  [[45.96,49.13],[48.19,40.86],[50.21,41.29],[48.16,49.12]],
  [[3.69,48.83],[9.63,32.98],[11.75,32.8],[5.59,49.42]],
  [[26.28,48.89],[28.23,49.31],[30.97,37.97],[29.03,37.55]],
  [[-22.15,48.92],[-24.64,48.94],[-26.57,44.41],[-24.3,44.35]]
].map(path=>path.map(([z,y])=>[z,49.73-y]));
export const isLegacyAluSection = profiles => Array.isArray(profiles) &&
  profiles.length===LEGACY_ALU_SECTIONS.length && profiles.every((path,i)=>
    Array.isArray(path) && path.length===LEGACY_ALU_SECTIONS[i].length && path.every((p,j)=>
      Array.isArray(p) && p.length===2 && p.every((v,k)=>Math.abs(v-LEGACY_ALU_SECTIONS[i][j][k])<1e-7)));
